import React from 'react'
import Link from 'gatsby-link'
import styled from 'react-emotion';
import ChapterDisplay from "../components/ChapterDisplay";
import PageContainer from "../components/common/PageContainer";
import PageTitle from "../components/common/PageTitle";
import Header from "../components/Header";
import Footer from "../components/Footer";

const PageBody = styled.div`
  padding: 20px;
  flex-grow: 1;

  & ul {
    list-style-type: none;
    margin-left: 0;
  }
`

const ToCPage = (props) => (
  <PageContainer justify="flex-start">
    <Header background="#222"/>
    <PageBody>
      <h1>Table of Contents</h1>
      <ul>
      { props.data.chapters ? props.data.chapters.edges.map((chapter) => 
        <ChapterDisplay key={chapter.node.id} chapter={chapter.node} />
      ) : null }
      </ul>
    </PageBody>
    <Footer background="#222"/>
  </PageContainer>
)

export default ToCPage

export const pageQuery = graphql`
query ToCPageQuery {
  chapters: allContentfulChapter(sort:{ fields:[chapterNumber], order:ASC}) {
    edges{
      node {
        id
        title
        subtitle{
          childMarkdownRemark {
            html
          }
        }
        slug
        chapterNumber
        updatedAt
        page{
          id
          title
          pageNumber
          path
          updatedAt
        }
      }
    }
  }
}
`


// WEBPACK FOOTER //
// ./src/pages/table-of-contents.js